import styled from 'styled-components'
import { Color, MediaBreakpoint } from 'root-constants'
import { Button } from 'components/Button'

export const StyledPurchaseVariant1 = {
  Wrapper: styled.div`
    margin: 0 auto;
    padding-bottom: 20px;
    position: relative;
    z-index: 2;
  `,
  Title: styled.h2`
    margin: 16px 0;
    padding: 0 16px;
    max-width: 360px;
    font-weight: 700;
    font-size: 28px;
    line-height: 38px;
    text-align: center;
    color: ${Color.WHITE};

    & strong {
      color: ${Color.ORANGE};
    }
  `,
  Hero: styled.div`
    position: relative;
    max-width: ${MediaBreakpoint.MAX_PHONE}px;
    margin: 0 auto 24px;
    width: 100%;
    aspect-ratio: 360/295;

    &::before {
      content: '';
      position: absolute;
      height: 113px;
      width: 100%;
      top: 0;
      background: linear-gradient(
          163.8deg,
          rgba(51, 35, 75, 0) 60.97%,
          rgba(51, 35, 75, 0.32) 74.68%,
          #2b2144 89.57%
        ),
        linear-gradient(193.03deg, rgba(51, 35, 75, 0) 57.9%, #362237 91.38%);
      transform: rotate(-180deg);
    }

    &::after {
      content: '';
      position: absolute;
      height: 113px;
      width: 100%;
      bottom: 0;
      background: linear-gradient(
        180deg,
        rgba(65, 191, 225, 0) 0%,
        rgba(108, 73, 231, 0.29) 41.37%,
        #13182a 100%
      );
    }

    @media screen and (min-width: ${MediaBreakpoint.MAX_PHONE}px) {
      max-width: 360px;
    }
  `,
  Received: styled.div`
    margin-bottom: 32px;
    padding: 0 16px;
    max-width: 360px;
  `,
  ListItem: styled.li`
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: left;
    display: flex;
    align-items: flex-start;
    color: ${Color.LIGHT};

    svg {
      margin-right: 10px;
      min-width: 30px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  `,
  ListTitle: styled.h2`
    margin-bottom: 24px;
    line-height: 33px;
    text-align: center;
  `,
  ProgramPlanContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  FeaturedBlockContainer: styled.div`
    margin-bottom: 52px;
  `,
  Button: styled(Button)`
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
  `,
  CustomerReviewsContainer: styled.div`
    background-color: ${Color.LIGHT};
    border-radius: 36px 36px 0 0;
    padding: 24px 16px;
    overflow: hidden;
  `,
  Disclaimer: styled.p`
    padding-bottom: 32px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    letter-spacing: -0.154px;
    color: ${Color.DISABLED};
  `,
}
